import { render, staticRenderFns } from "./UserProfileSidebar.vue?vue&type=template&id=cdcadf54&scoped=true&"
import script from "./UserProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./UserProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileSidebar.vue?vue&type=style&index=0&id=cdcadf54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcadf54",
  null
  
)

export default component.exports